import { EXTERNAL_TOKEN_KEY } from '../constants';
import { APP_WATCH_SHARED_DATA } from '@/modules/common/constants/globals';

import { RawWatchType } from '@/modules/common/types';

export const getToken = (): string => window[APP_WATCH_SHARED_DATA][EXTERNAL_TOKEN_KEY];

let externalEmbedData = {
  ...window.ac_vh_params,
};

/**
 * Sets the external embed data by extracting values from `window.ac_vh_params`.
 */
export const setExternalEmbedData = (): void => {
  externalEmbedData = {
    ...window.ac_vh_params,
  };
};

setExternalEmbedData();

export const getContainerId = (): string => externalEmbedData.containerId;
export const getFolderName = (): string => externalEmbedData.folderName;
export const getChannelArray = (): number[] | undefined => externalEmbedData.channelArray;
export const getEscapedFolderName = (escapedSymbol = '_'): string =>
  externalEmbedData.folderName.replace(/\//g, escapedSymbol);
export const getOverrideConfig = (): RawWatchType => {
  let { overrideConfig } = externalEmbedData;

  if (!overrideConfig) {
    overrideConfig = {
      channels: [],
    };
  }

  if (!overrideConfig.channels) {
    overrideConfig.channels = [];
  }

  return overrideConfig;
};
export const getUsOpenShareUrl = (): string | undefined => externalEmbedData.usOpenShareUrl;

export const { isInternalType } = externalEmbedData;
